import { useState } from "react"
import { formatKsh } from "./utilityAdminDisplay"

const PAGE_SIZE = 5

function CustomerBalance({ customer }) {
  if (customer.owed > 0) {
    return (
      <>
        <p className="text-xs font-bold text-rose-600">{formatKsh(customer.owed)}</p>
        <p className="text-[9px] uppercase tracking-wide text-gray-400">Owes</p>
      </>
    )
  }
  if (customer.credit > 0) {
    return (
      <>
        <p className="text-xs font-bold text-emerald-700">{formatKsh(customer.credit)}</p>
        <p className="text-[9px] uppercase tracking-wide text-gray-400">Credit</p>
      </>
    )
  }
  return (
    <>
      <p className="text-xs font-semibold text-gray-400">{formatKsh(0)}</p>
      <p className="text-[9px] uppercase tracking-wide text-gray-400">Settled</p>
    </>
  )
}

function UtilityCustomerList({ customers = [], onLogin }) {
  const [showCount, setShowCount] = useState(PAGE_SIZE)

  if (customers.length === 0) {
    return <p className="rounded-lg border border-dashed border-gray-200 bg-white p-3 text-xs text-gray-400">No customers yet.</p>
  }

  const visible = customers.slice(0, showCount)
  return (
    <div className="overflow-hidden rounded-lg border border-gray-100 bg-white">
      <div className="divide-y divide-gray-50">
        {visible.map((customer) => (
          <div key={customer.id} className="flex items-center gap-2 px-2.5 py-2">
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1.5">
                <p className="truncate text-xs font-semibold text-gray-800">{customer.name}</p>
                {customer.autoInvoiceEnabled === true && (
                  <span className="flex-shrink-0 rounded border border-emerald-100 bg-emerald-50 px-1 text-[8px] font-semibold text-emerald-600">
                    AUTO
                  </span>
                )}
                {customer.status === "removed" && (
                  <span className="flex-shrink-0 rounded border border-gray-200 bg-gray-100 px-1 text-[8px] font-semibold text-gray-400">
                    REMOVED
                  </span>
                )}
              </div>
              <p className="truncate text-[10px] text-gray-400">{customer.phone || "No phone"}</p>
              {Number(customer.utWallet || 0) !== 0 && (
                <p className="truncate text-[10px] font-medium text-teal-700">Wallet {formatKsh(customer.utWallet)}</p>
              )}
            </div>
            <div className="flex-shrink-0 text-right">
              <CustomerBalance customer={customer} />
            </div>
            {onLogin && (
              <button
                type="button"
                onClick={() => onLogin(customer.id)}
                className="flex-shrink-0 rounded-md border border-emerald-100 px-2 py-1.5 text-[10px] font-semibold text-emerald-700 transition-colors hover:bg-emerald-50"
                title={`Log in as ${customer.name}`}
              >
                Log in
              </button>
            )}
          </div>
        ))}
      </div>
      {customers.length > showCount && (
        <button
          type="button"
          onClick={() => setShowCount((count) => count + 10)}
          className="w-full border-t border-gray-50 px-3 py-2 text-left text-[11px] font-medium text-emerald-700 hover:bg-emerald-50/40"
        >
          Show more customers ({customers.length - showCount})
        </button>
      )}
    </div>
  )
}

export default UtilityCustomerList
